import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { EquipmentFilters } from 'src/app/domains/equipment/models';

@Component({
  selector: 'gdp-equipment-filters',
  templateUrl: './equipment-filters.component.html',
  styleUrls: ['./equipment-filters.component.scss']
})
export class EquipmentFiltersComponent implements OnInit {
  @Input() lockedFilters: string[];
  @Input() filters: EquipmentFilters;
  @Input() limitedAvailableFilters: string[];
  @Output() filtersChanged = new EventEmitter<EquipmentFilters>()
  public form: UntypedFormGroup;
  public availableFilters = ['ipui', 'model', 'alphaname', 'pbxId'];
  public usedFilters: string[] = ['macAddress'];
  public models: Array<string> = ['SMART_V1', 'SMART_V2', 'AIR', 'CONTROL'];
  public macAddressPattern = /^([0-9A-Fa-f]{2}[:-]?){5}([0-9A-Fa-f]{2})$/;
  public ipuiPattern = /^([0-9A-Fa-f]{10}|([0-9A-Fa-f]{2}-){4}[0-9A-Fa-f]{2}|([0-9A-Fa-f]{2}:){4}[0-9A-Fa-f]{2})$/;
  public disabledItem: boolean = false;

  constructor() {}

  ngOnInit() {
    this.initFilters();
  }

  private initFilters() {
    this.availableFilters = [];
    this.usedFilters = [];
    Object.keys(this.filters).forEach(k => {
      this.availableFilters.push(k)
    });
    if(this.lockedFilters) {
      for(let i=0; i < this.availableFilters.length; i++) {
        for(let j=0; j < this.lockedFilters.length; j++) {
          if(this.lockedFilters[j] === this.availableFilters[i]) {
            this.availableFilters.splice(i, 1);
            this.limitedAvailableFilters.splice(i, 1);
            this.usedFilters.push(this.lockedFilters[j]);
          }
        }
      }
    }
    this.usedFilters.push(this.availableFilters[0]);
    this.limitedAvailableFilters.forEach(el => {
      if(el === this.availableFilters[0]) {
        const index = this.limitedAvailableFilters.indexOf(el);
        this.limitedAvailableFilters.splice(index, 1);
      }
    });
    this.availableFilters.splice(0, 1);
    this.form = new UntypedFormGroup({});
    this.usedFilters.forEach(el => {
      this.addFormControls(el);
    });
  }

  private addFormControls(value) {
    switch(value) {
      case 'model':
        this.form.addControl(value, new UntypedFormControl(this.models[0]));
        break;
      case 'macAddress':
        this.form.addControl(value, new UntypedFormControl('', [Validators.pattern(this.macAddressPattern)]));
        break;
      case 'ipui':
        this.form.addControl(value, new UntypedFormControl('', [Validators.pattern(this.ipuiPattern)]));
        break;
      default:
        this.form.addControl(value, new UntypedFormControl(this.filters[value]));
        break;
    }
  }

  public addFilter(index: number) {
    let filter: string = this.limitedAvailableFilters[index];
    this.usedFilters.push(this.limitedAvailableFilters[index]);
    this.limitedAvailableFilters.splice(0, 1);
    this.availableFilters.forEach(el => {
      if(el === filter) {
        const i = this.availableFilters.indexOf(el);
        this.availableFilters.splice(i, 1)
      }
    });
    this.addFormControls(filter);
    this.disableItem();
  }

  public isDisabledAddFilters() {
    let result: boolean;
    this.usedFilters.includes
    this.usedFilters.forEach(el => {
      if(['macAddress', 'ipui'].includes(el)) result = true;
      else result = false;
    });
    return result;
  }

  public canRemoveFilter(uIdx:number):boolean {
    return !(this.lockedFilters && this.lockedFilters.includes(this.usedFilters[uIdx]));
  }

  public disableItem() {
    this.usedFilters.forEach(el => {
      if (
        !this.lockedFilters &&
        this.usedFilters.length !== 1 &&
        this.usedFilters.length >= 2 && 
        ['model', 'alphaname', 'pbxId'].includes(el)
        ) 
      this.disabledItem = true;
      else this.disabledItem = false;
    });
  }

  public removeFilter(index: number) {
    let filter = this.usedFilters[index];
    this.limitedAvailableFilters.push(this.usedFilters[index]);
    this.availableFilters.push(this.usedFilters[index]);
    this.usedFilters.splice(index, 1);
    this.form.removeControl(filter);
    this.disableItem();
  }

  public emitFilters() {
    if (this.form.valid) {
      let value = this.form.value;
      this.filtersChanged.emit(value);
    }
  }

  public updateFilters(index: number, oldIndex: number) {
    let toRemove: string = this.usedFilters[oldIndex];
    let toAdd: string = this.availableFilters[index];
    if(['macAddress', 'ipui'].includes(toAdd)) {
      if(this.lockedFilters) {
        for(let i=0; i < this.usedFilters.length; i++) {
          if(this.lockedFilters[i] !== this.usedFilters[i]) {
            this.availableFilters.push(this.usedFilters[i]);
            this.form.removeControl(this.usedFilters[i]);
          }
        }
      } else {
        this.usedFilters.forEach(used => {
          this.availableFilters.push(used);
          if(['model', 'alphaname', 'pbxId'].includes(used)) {
            this.limitedAvailableFilters.push(used);
          }
          this.form.removeControl(used);
        });
      }
      this.usedFilters = [];
      if(this.lockedFilters) {
        this.lockedFilters.forEach(el => {
          this.usedFilters.push(el);
          this.addFormControls(el);
        });
      }
      this.usedFilters.push(toAdd);
      this.addFormControls(toAdd);
      this.availableFilters.splice(index, 1);
    } else {
      this.usedFilters[oldIndex] = this.availableFilters[index];
      this.limitedAvailableFilters.forEach(el => {
        if(el === this.availableFilters[index]) {
          const i = this.limitedAvailableFilters.indexOf(this.availableFilters[index]);
          this.limitedAvailableFilters.splice(i, 1);
        }
      });
      this.availableFilters.splice(index, 1);
      this.availableFilters.push(toRemove);
      this.availableFilters.sort();
      if(['model', 'alphaname', 'pbxId'].includes(toRemove)) {
        this.limitedAvailableFilters.push(toRemove);
      }
      this.form.removeControl(toRemove);
      this.addFormControls(toAdd);
      this.disableItem();
    }
  }

  public resetFilters() {
    if(this.lockedFilters) {
      for(let i=0; i < this.availableFilters.length; i++) {
        for(let j=0; j < this.lockedFilters.length; j++) {
          if(this.lockedFilters[j] === this.availableFilters[i]) {
            this.availableFilters.splice(i, 1);
            this.limitedAvailableFilters.splice(i, 1);
          }
        }
      }
    } else {
      this.usedFilters.forEach(el => {
        this.availableFilters.push(el);
        if(['model', 'alphaname', 'pbxId'].includes(el)) {
          this.limitedAvailableFilters.push(el);
        }
      });
      this.availableFilters.forEach(el => {
        if(el === 'macAddress') {
          const index = this.availableFilters.indexOf(el);
          this.availableFilters.splice(index, 1);
        }
      });
      this.usedFilters = ['macAddress'];
    }
    this.form = new UntypedFormGroup({});
    this.usedFilters.forEach(el => {
      this.addFormControls(el);
    });
    this.disableItem();
  }

}
